var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftBorderClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    style: {
      position: "absolute",
      left: "-10000px",
      top: "-10000px",
      zIndex: -1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nft_avatar",
    clipPathUnits: "objectBoundingBox",
    transform: "scale(0.018518518518518517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6361 20C53.8899 23.9763 53.8899 28.8442 51.6361 32.8206L48.2425 38.8078L44.7542 44.7402C42.4375 48.6803 38.2218 51.1142 33.6513 51.1505L26.7694 51.2053L19.8876 51.1505C15.317 51.1142 11.1014 48.6803 8.78459 44.7402L5.2963 38.8078L1.90276 32.8206C-0.351051 28.8442 -0.351049 23.9763 1.90276 19.9999L5.2963 14.0128L8.7846 8.08024C11.1014 4.14019 15.317 1.70627 19.8876 1.66994L26.7694 1.61523L33.6513 1.66994C38.2218 1.70627 42.4375 4.1402 44.7542 8.08024L48.2425 14.0128L51.6361 20Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftBorderClip);
export default __webpack_public_path__ + "static/media/nft-border-clip.fc1ec9fbbcd8734a26a72b09f79ea2a6.svg";
export { ForwardRef as ReactComponent };